import { useEffect, useState } from "react";
import { api } from "@/api/client";
import { useStore } from "@/state/store";
import type { EvalEvent } from "@offsite/shared";
import { EvalTransparencyPanel } from "./EvalTransparencyPanel";
import { EvalEventFeed } from "./EvalEventFeed";

export function EvaluationProgress() {
  const { state } = useStore();
  const [progress, setProgress] = useState<{ total: number; completed: number } | null>(null);
  const [events, setEvents] = useState<EvalEvent[]>([]);

  useEffect(() => {
    let cancelled = false;
    const loadProgress = async () => {
      try {
        const r = await api.eval.progress(state.auth.token);
        if (!cancelled) setProgress(r);
      } catch {
        /* noop */
      }
    };
    loadProgress();
    const id = setInterval(loadProgress, 3000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [state.auth.token]);

  useEffect(() => {
    let cancelled = false;
    const loadEvents = async () => {
      try {
        const r = await api.eval.events(state.auth.token);
        if (!cancelled) setEvents(r.events);
      } catch {
        /* noop */
      }
    };
    loadEvents();
    const id = setInterval(loadEvents, 2000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [state.auth.token]);

  const total = progress?.total ?? 0;
  const completed = progress?.completed ?? 0;
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;
  const done = total > 0 && completed >= total;

  return (
    <section style={{ display: "grid", gap: 18, padding: "1.5rem 0" }}>
      <header style={{ textAlign: "center", display: "grid", gap: 6 }}>
        <div className="deck-eyebrow">KI bewertet</div>
        <h2
          className="deck-title"
          style={{ fontSize: "clamp(1.4rem, 4.5vw, 1.85rem)", margin: 0 }}
        >
          {done ? "Alle Teams bewertet" : "Die KI prüft eure Anforderungen"}
        </h2>
        <p className="deck-sub" style={{ marginTop: 4 }}>
          {done
            ? "Gleich erscheinen die Ergebnisse auf dem Beamer."
            : "Mehrere Teams werden parallel bewertet — die Resultate kommen gleich."}
        </p>
      </header>

      <div className="progress-card">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: 14,
            color: "var(--svo-grau-500)",
          }}
        >
          <span>Fertig</span>
          <strong
            style={{
              color: "var(--svo-dunkelblau)",
              fontVariantNumeric: "tabular-nums",
            }}
          >
            {completed} / {total || "…"}
          </strong>
        </div>
        <div className="progress-track">
          <div
            className={`progress-fill${done ? " is-done" : ""}`}
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>

      <EvalEventFeed events={events} max={8} />

      <EvalTransparencyPanel />
    </section>
  );
}
